/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { DZ } from '../../../../../api';
import { size, map } from 'lodash';
import { Loader, Pagination, Search, Popup } from 'semantic-ui-react';
import { AsesorDZItem } from '../AsesorDZItem/AsesorDZItem';
import { useAuth } from '../../../../../hooks';

const DZController = new DZ();

export function ListDZAsesor(props) {
  const { reload, onReload, onClose } = props;
  const [DZs, setDZs] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState();
  const [searchTerm, setSearchTerm] = useState('');
  const { user: { email } } = useAuth();
  const CorreoAsesor = email;

  const fetchDZs = async (page) => {
    try {
      const response = await DZController.getDZsByAsesor(CorreoAsesor, { page, limit: 10 });
      return response;
    } catch (error) {
      console.error(error);
      return { docs: [], limit: 0, page: 0, pages: 0, totalPages: 0 };
    }
  };

  const loadDZs = async () => {
    const response = await fetchDZs(page);
    setDZs(response.docs);
    setPagination({
      limit: response.limit,
      page: response.page,
      pages: response.pages,
      total: response.totalPages,
    });
  };

  const loadAllDZs = async () => {
    let allDZs = [];
    for (let i = 1; i <= pagination.total; i++) {
      const response = await fetchDZs(i);
      allDZs = allDZs.concat(response.docs);
    }
    return allDZs;
  };


  useEffect(() => {
    loadDZs();
  }, [page, reload]);

  useEffect(() => {
    if (searchTerm) {
      (async () => {
        const allDZs = await loadAllDZs();
        setDZs(allDZs);
      })();
    } else {
      loadDZs();
    }
  }, [searchTerm, reload]);

  const changePage = (_, data) => {
    setPage(data.activePage);
  };

  const handleSearchChange = (_, { value }) => {
    setSearchTerm(value);
  };

  const filterDZs = () => {
    if (!searchTerm) {
      return DZs;
    } else {
      return DZs.filter(DZ =>
        (DZ.folio && DZ.folio.toString().toLowerCase().includes(searchTerm.toLowerCase()))
      );
    }
  };


  if (!DZs) return <Loader active inline="centered" />;
  if (size(DZs) === 0) return "No hay cotizaciones";

  return (
    <div className='list-cotizaciones'>
      <Popup trigger={<Search
        onSearchChange={handleSearchChange}
        value={searchTerm}
        placeholder="Buscar..."
        showNoResults={false}
      />}
        header='Busca por:'
        content='Folio de fórmula'
      />
      <br />
      {map(filterDZs(), DZ => (
        <AsesorDZItem key={DZ._id} DZ={DZ} onReload={onReload} onClose={onClose} />
      ))}
      <div className='list-cotizaciones__pagination'>
        <Pagination
          totalPages={pagination.total}
          defaultActivePage={pagination.page}
          ellipsisItem={null}
          firstItem={null}
          lastItem={null}
          onPageChange={changePage}
        />
      </div>
    </div>
  );
}
